import { useMutation } from '@tanstack/react-query'
import { BiometryService } from '../services'
import { BiometryActionType } from '../types'

type BiometryStartMutation = {
  withoutLogin: boolean
  cpf: string
  captcha: string
  callbackUri: string
  clinicId?: number
  action?: BiometryActionType
}

export const useBiometryStart = () => {
  const mutation = useMutation({
    mutationFn: async (params: BiometryStartMutation) => {
      if (params?.clinicId) {
        const response = await BiometryService.biometryStartWithClinic({
          callbackUri: params.callbackUri,
          cpf: params.cpf,
          captcha: params.captcha,
          clinicId: params.clinicId,
          action: params.action,
        })

        return response
      }

      if (params?.withoutLogin) {
        const response = await BiometryService.biometryStartPatient(
          params?.callbackUri,
          params?.cpf,
          params?.captcha,
        )
        return response
      }

      const response = await BiometryService.biometryStart(params?.callbackUri)

      return response
    },
  })

  return mutation
}
